export const NATIVE_SOL_MINT = 'So11111111111111111111111111111111111111112'; 